export default __webpack_public_path__ + "static/media/unfilledDatesIcon.8407dcf4.svg";